import { createCoreConfig, type Environment } from '@dt-pm/core';



export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:3000/bff',
  environment: (import.meta.env.VITE_ENVIRONMENT ?? 'development') as Environment,
  realtimeUrl: import.meta.env.VITE_REALTIME_URL ?? '',
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '',
  enableTimerMiniPlayer: import.meta.env.VITE_ENABLE_TIMER_MINI_PLAYER !== 'false',
  appVersion: __APP_VERSION__,
  isProduction: import.meta.env.PROD,
};

export const coreConfig = createCoreConfig({
  apiBaseUrl: env.apiBaseUrl,
  environment: env.environment,
  clientVersion: env.appVersion,
  clientOrigin: 'web',
});
